import { ErrorPage } from "@/components/ui/ErrorPage";

export default function NotFound() {
  return (
    <ErrorPage
      emoji="🧭"
      titolo="404 — Pagina non trovata"
      messaggio="La pagina che cerchi non esiste o è stata spostata."
      cta={{ label: "Torna alla home", to: "/" }}
    />
  );
}
